module.exports = __webpack_public_path__ + "img/slide10.ede97316.png";